// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".7b80a63d3ac197ecceed28184c692c13a9119ce6.chunk.bundle.js";
};